export default "__VITE_ASSET__bcPAlnWa__"